/* eslint-disable no-unused-vars */
export enum IconSizes {
  LARGE = 'large-icon',
  SMALL = 'small-icon',
}
